/**
 * Manager Panel Constants
 * Shared constants and utilities for manager components
 */

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Garden Centre categories (Burston)
export const TIP_CATEGORIES = [
    { value: 'wildlife', label: 'Wildlife' },
    { value: 'vegetables', label: 'Vegetables' },
    { value: 'flowers', label: 'Flowers' },
    { value: 'seasonal', label: 'Seasonal' },
    { value: 'plants', label: 'Plants' },
    { value: 'indoor', label: 'Indoor' },
    { value: 'general', label: 'General' }
];

// Residential categories (Elysian)
export const WELLNESS_CATEGORIES = [
    { value: 'fitness', label: 'Fitness' },
    { value: 'mindfulness', label: 'Mindfulness' },
    { value: 'nutrition', label: 'Nutrition' },
    { value: 'social', label: 'Social Activities' },
    { value: 'health', label: 'Health Tips' },
    { value: 'lifestyle', label: 'Lifestyle' },
    { value: 'general', label: 'General' }
];

export const TIP_SEASONS = [
    { value: 'spring', label: 'Spring' },
    { value: 'summer', label: 'Summer' },
    { value: 'autumn', label: 'Autumn' },
    { value: 'winter', label: 'Winter' },
    { value: 'all_year', label: 'All Year' }
];

export const formatDateTime = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleString('en-GB', { 
        day: 'numeric', 
        month: 'short', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};
